import { cx } from '@linaria/core';
import { TransitionGroup } from 'react-transition-group';
import { Link } from '@provider/navigation';
import { resets } from '@ui/css';
import { CSSRefTransition, Chevron } from '@utils/react';
import { iconWrapper, iconTransitionDurationMs, wrapper, modifiers } from './circular.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function CircularButton({
  size,
  inversed,
  theme,
  icon,
  iconKey,
  as,
  ...props
}) {
  const Comp = as === "a" ? Link : as ?? "button";
  return /*#__PURE__*/jsxs(Comp
  // @ts-expect-error We should be allowed to type our ref as an
  // HTMLElement
  , {
    ref: props.ref,
    ...props,
    className: cx(resets.rootCls, wrapper, props.className, !icon && modifiers.defaultIcon.className, theme === "black" && modifiers.black.className, theme === "accent" && modifiers.accent.className, size === "large" && modifiers.large.className, size === "small" && modifiers.small.className, inversed && modifiers.inversed.className),
    children: [/*#__PURE__*/jsx(TransitionGroup, {
      component: null,
      children: /*#__PURE__*/jsx(CSSRefTransition, {
        timeout: iconTransitionDurationMs,
        classNames: iconWrapper,
        children: ref => /*#__PURE__*/jsx("span", {
          ref: ref,
          className: cx(iconWrapper),
          children: icon ?? /*#__PURE__*/jsx(Chevron, {
            lineWidth: size === "large" ? 2 : 1.5,
            size: size === "large" ? 14 : 12,
            inversed: inversed
          })
        })
      }, iconKey || "default")
    }), props.children]
  });
}

export { CircularButton };
//# sourceMappingURL=circular.js.map
